import { 
  SETTINGS_REQUEST,
  SETTINGS_ERROR,
  SETTINGS_SUCCESS,
  SETTINGS_EMPTY,
  SETTINGS_UPDATE,
  SETTINGS_STORE,
} from '../actions/settings'

import Api from '@/services/Api'

const state = {
  status: '',
  settings: localStorage.getItem('settings')?JSON.parse(localStorage.getItem('settings')):{},
};

const getters = {
};

const actions = {
  [SETTINGS_REQUEST]: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit(SETTINGS_REQUEST)

      Api().get('/configurations')
          .then(function (response) {
            localStorage.setItem('settings', JSON.stringify(response.data.data));
            commit(SETTINGS_SUCCESS);

            commit(SETTINGS_STORE, response.data.data);

            resolve(response.data.data);
          })
          .catch(function (error) {
            commit(SETTINGS_ERROR);
            reject(error);
          });
    })
  },

  [SETTINGS_UPDATE]: ({commit}, settings) => {
    return new Promise((resolve, reject) => {
      commit(SETTINGS_REQUEST)

      Api().post('/configurations', settings)
        .then(function (response) {
          commit(SETTINGS_SUCCESS);
          resolve(response);
        })
        .catch(function (error) {
          commit(SETTINGS_ERROR);
          reject(error);
        });
    })
  },

};

const mutations = {
  [SETTINGS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [SETTINGS_SUCCESS]: (state) => {
    state.status = 'success';
  },

  [SETTINGS_EMPTY]: (state) => {
    state.status = 'empty';
  },
  [SETTINGS_ERROR]: (state) => {
    state.status = 'error';
  },

  [SETTINGS_STORE]: (state, response) => {
    // console.log(response);
    // state.settings = response;
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
